<template>
  <div class="mobile-header" :style="`color: ${fColor};background: ${bg}`">
    <div @click="touchLeft()" style="width: 9vw;">
      <span class="iconfont icon-arrow-left"></span>
    </div> 
    <div class="header-title" @click="goto">{{ title }}{{isTest ? edition: ''}}</div>
    <img
      v-if="rightType == 'scanCode'"
      style="height: 9vw"
      src="@/assets/images/psz.png"
      @click="scanCode"
    />
    <!-- <img src="@/assets/images/share-icon.png" alt=""> -->
    <div v-if="rightType == 'share'" style="width: 9vw;justify-content: flex-end;">
      <span @click="share" class="iconfont icon-fenxiang"></span>
    </div>
    <div v-if="rightType == 'none'" style="width: 9vw;justify-content: flex-end;"></div>
    <!-- <input type="text" v-if="isTest" /> -->
    <!-- <van-popup v-model="showSelect">
      <div class="select-type">
        <div @click="mixScanCode(analysisCode, 'qrCode')">单个扫码</div>
        <div @click="mixScanCode(analysisCode, 'qrCode_batch')">多个扫码</div>
      </div>
    </van-popup> -->
    <div class="select-box" v-if="showSelect" @click="showSelect = false">
      <div class="select-type">
        <div @click="mixScanCode(analysisCode, 'qrCode')">单个扫码</div>
        <div @click="mixScanCode(analysisCode, 'qrCode_batch')">多个扫码</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
export default {
  props: {
    title: {
      type: String,
    },
    rightType: {
      type: String,
      default: "none",
    },
    fColor: {
      type: String,
      default: "#ffffff",
    },
    bg: {
      type: String,
      default: "#2E8DFF",
    },
    shopId: {
      type: [String, Number],
      default: null,
    },
  },
  computed:{
    userRole() {
      return this.$store.state.userRole;
    },
    isTest(){
      return this.$store.state.isTest
    }
  },
  data(){
    return {
      showSelect: false,
      url: "http://192.168.0.110:8081/h5/#",
      // url: "http://192.168.137.1:8081/h5/#",
      edition: "(测试版)♞⛴♬"
    }
  },
  methods: {
    touchLeft() {
      // console.log(this.$route.path == '/flowPath/index',"this.$route.path == this.$store.state.startRouter")
      if((this.$store.state.userRole == 1 && this.$store.state.userRole == 2) || this.$route.path == '/flowPath/index')return JS.close();
      if (this.$route.meta.index == 1 || this.$route.path == this.$store.state.startRouter) {
        JS.close();
      } else {
        this.$router.go(-1);
      }
    },
    goto(){
      console.log(this.isTest,"isTest")
      if(this.isTest){
        window.open(this.url + this.$route.fullPath,'_top')

      }
      // window.open('http://192.168.100.25:8080/h5/#'+this.$route.fullPath,'_top')
      // window.open('http://192.168.100.25:8080/h5#/search/BottleInfo','_top')
      // this.$router.push('/flowPath/collect?state=1')
    },
    share(){
      console.log("门店id", this.shopId)
      JS.share(this.shopId || this.$store.state.userShopID)
    },
    scanCode(){
      if(this.$store.state.userRole == 3)return this.mixScanCode(this.analysisCode, 'qrCode')
      this.showSelect = true
      // this.mixScanCode(this.analysisCode, "qrCode_batch")
      // if (this.$listeners.scanCode) {
      //   this.$emit('scanCode')
      // } else {
      // }
    },
    async analysisCode({data}) {
      console.log("扫码回调")
      this.showSelect = false
      // const ret = JSON.parse(res.data);
      const ret = {
        bottleId: this.mixDecode(data)
      }
      console.log(ret,"--------------------------------------------")
      if (!ret.bottleId)return Toast({ message: "请扫正确的二维码", duration: 500 });
      console.log(ret.bottleId,"ret.bottleId")
      if(this.$listeners.scanCode)return this.$emit('scanCode', ret.bottleId)

      if(ret.bottleId.indexOf(",") != -1){
        this.$store.state.isMultiple = true
        const codeList = []
        ret.bottleId.split(",").map(code => {
          codeList.push(this.mixDecode(code))
        })
        // this.$store.state.bottleIdList = codeList
        const bottleListData = await this.mixfilterBottle(codeList)
        this.$store.state.bottleListData = bottleListData
        console.log(bottleListData,"bottleListData")
        this.$store.state.bottleIdList = bottleListData.map(it => it.ewm)
        // this.$store.state.bottleIdList = await this.mixfilterBottle(codeList)
        this.$route.path != '/flowPath/index' && this.$router.push("/flowPath/index?bottleId=" + ret.bottleId)
        return false
      }else{
        this.$store.state.isMultiple = false
      }
      
      console.log(this.userRole,"this.userRole")
      if (this.userRole == 3) {
        const { code, msg } = await this.mixGetBottleInfo(null, 1);
        if(code != 200) return Toast({ message: msg, duration: 500 })
        this.$store.state.bottleId = ret.bottleId;
      } else {
        const { code, msg } = await this.mixGetBottleInfo(ret.bottleId);
        console.log(code, msg,"code, msg")
        if(code != 200) return Toast({ message: msg, duration: 500 })
        console.log(this.$route.path,"this.$route.path")
        console.log(this.$route.path != '/flowPath/index',"this.$route.path != '/flowPath/index'")
        this.$route.path != '/flowPath/index' && this.$router.push("/flowPath/index?bottleId=" + ret.bottleId)
        this.$store.state.bottleId = ret.bottleId;
      }
    },
  },
  created() {
    process.env.VUE_APP_BASE_API == "/api" && (this.edition = this.$route.path);
    window.JS && JS.setStatusBackground('255', ...this.bg.colorRgb());
  },
};
</script>

<style lang="scss" scoped>
.mobile-header {
  width: 100%;
  height: 10vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 3vw;
  position: sticky;
  top: 0;
  z-index: 99;
  line-height: 10vw;
  box-sizing: border-box;
  & > img {
    padding: 1vw;
  }
  & > div {
    display: flex;
    img {
      width: 20px;
    }
  }
  .icon-arrow-left, .icon-fenxiang {
    font-size: 8vw;
  }
}
::v-deep .van-popup{
  background: rgba(255, 255, 255, 0);
}
.select-box{
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  padding-top: 10vw;
}
.select-type{
  background: #cbcdcc;
  margin: 0 0 auto auto;
  color: #333;
  display: block;
  width: 26vw;
  height: fit-content;
  text-align: center;
  border-radius: 1vw;
  margin-top: -1vw;
  
  & > div{
    width: 100%;
    color: white;
    font-size: 4vw;
    line-height: 20vw;
    border-radius: 2vw;
    position: relative;
  }
  & > div + div{
    &::before{
      content: "";
      left: 10%;
      top: 0;
      width: 80%;
      height: 1px;
      position: absolute;
      background: #dedee0;
    }
  }
  & > div:active{
    background: rgba(241, 239, 239, 0.411);
  }
}
</style>